import script from "./BaseComponent.vue?vue&type=script&lang=js"
export * from "./BaseComponent.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__